export default __webpack_public_path__ + "static/media/local-redis-python.8f01181b.png";